import { previewState } from "@/atoms/quote/preview-state";
import { toastState } from "@/atoms/system/toast-state";
import { ButtonColor } from "@/common/enum/button-color";
import { H4 } from "@/components/typography/H4";
import { MemoItem } from "@/types/dto/quote-detail-dto";
import { Button, Modal, TextInput } from "flowbite-react";
import { useEffect, useState } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";

function EditMemoModal({ index }: { index: number }) {
  const setToast = useSetRecoilState(toastState);
  const [preview, setPreview] = useRecoilState(previewState);
  const [memoInputs, setMemoInputs] = useState<MemoItem[]>([]);
  const [originalMemoInputs, setOriginalMemoInputs] = useState<MemoItem[]>([]);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!preview?.cartItems[index]?.memoItems || !preview.canEdit) return;

    const memoItems = preview.cartItems[index].memoItems;
    if (memoItems.length > 0) {
      setMemoInputs(memoItems);
      setOriginalMemoInputs(memoItems);
    }
  }, [preview, index]);

  const isChanged = () => {
    return memoInputs.some(
      (memo, index) =>
        memo.value !== originalMemoInputs[index]?.value && memo.value.length > 0
    );
  };

  const handleTextInputChange = (index: number, value: string) => {
    setMemoInputs((prev) =>
      prev.map((memo, i) => (i === index ? { ...memo, value } : memo))
    );
  };

  if (originalMemoInputs.length === 0) return null;

  return (
    <>
      <Modal show={open} onClose={() => setOpen(false)}>
        <Modal.Header>
          <H4>상품 메모 수정하기</H4>
        </Modal.Header>
        <Modal.Body>
          <div className="space-y-4">
            {memoInputs.map((memo, index) => (
              <div key={index} className="space-y-2">
                <label className="block text-sm font-medium text-gray-700">
                  {memo.name}
                </label>
                <TextInput
                  className="w-full"
                  value={memo.value}
                  onChange={(e) => handleTextInputChange(index, e.target.value)}
                  required
                  minLength={1}
                />
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex justify-start w-full">
            <Button
              color={isChanged() ? ButtonColor.PRIMARY : ""}
              onClick={() => {
                if (!preview) return;

                const updatedPreview = {
                  ...preview,
                  cartItems: preview.cartItems.map((item, i) =>
                    i === index ? { ...item, memoItems: memoInputs } : item
                  ),
                };
                setPreview(updatedPreview);
                setOriginalMemoInputs(memoInputs);
                setOpen(false);
                setToast({
                  show: true,
                  messages: ["메모가 수정되었습니다."],
                });
              }}
              disabled={!isChanged()}
            >
              수정하기
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <button
        onClick={() => setOpen(true)}
        className="rounded-md bg-grayscale-contrast-2 w-14 h-7 text-footnote-description text-semantic-text-body"
      >
        메모 수정
      </button>
    </>
  );
}

export default EditMemoModal;
